import {useRef} from "react";
import {kHomeTexts} from "../constants/texts";
import {LogoTextSize, renderLogoTextSize} from "../controllers/SystemUmmiaLogoTextController";
import {kHomeScreenImages, kSystemImages} from "../constants/images";
import {aboutScreenHighlightWords} from "../helpers/StringHelper";
import {SystemPrimaryCustomButton} from "../components/buttons/SystemCustomButton";
import {kButtonStyles} from "../constants/styles";
import {kPotLink, kYoutubeVideoLink} from "../constants/links";
import HomeAppStoreButton from "../components/buttons/homeScreen/HomeAppStoreButton";
import HomePlayStoreButton from "../components/buttons/homeScreen/HomePlayStoreButton";

export default function MobileRedirectScreen() {
    // Mobile Screen used in index.js to display message and mobile
    // app links

    // PROPERTIES
    const downloadSectionRef = useRef(null);
    const scrollToDownload = () => {
        downloadSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    // BUILD
    return(
        <div className={"animate-appearSlow bg-backgroundLight1 overflow-auto w-full h-[100svh] flex flex-col justify-start items-center"}>
            <div className={"overflow-auto w-full sm:hidden"}>
                {/** TOP BAR */}
                <div className={"bg-backgroundLight1 w-full h-[64px] min-h-[64px] max-h-[64px] flex justify-center items-center"}>
                    <div className={"w-full flex justify-between items-center px-[16px]"}>
                        <div className={`${renderLogoTextSize(LogoTextSize.SMALL)}`}>
                            <img className={"h-full object-contain"}
                                 src={kSystemImages.neoUmmiaLogoText}
                                 alt="Logo texte" />
                        </div>
                        <a href={kPotLink}
                           target="_blank"
                           rel="noopener noreferrer"
                           className={"cursor-pointer bg-white flex justify-center items-center space-x-[6px] whitespace-nowrap px-[10px] py-[6px] border-white border-[1px] rounded-[12px] ml-[16px]"}>
                            <div className={`animate-appear h-[20px] min-h-[20px] max-h-[20px] w-[22px] min-w-[22px] max-w-[26px]`}>
                                <img className={"object-contain h-full"}
                                     src={'/images/SystemFoxIcon.png'}
                                     alt="Flash logo" />
                            </div>
                            <span className={'text-primaryDark6 font-semibold font-playwrite text-[14px]'}>
                                {"Nous soutenir"}
                            </span>
                        </a>
                    </div>
                </div>
                {/** HOME SHOWCASE */}
                <div className={"bg-backgroundLight1 w-full min-h-[calc(100vh-64px)] flex flex-col justify-center items-center"}>
                    <div className={"w-full grow flex flex-col space-y-[48px] justify-center px-[16px] pb-[64px]"}>
                        <div className={"w-full flex flex-col space-y-[16px]"}>
                            <div className={"w-full text-center leading-tight"}>
                                    <span className={"text-white font-bold text-[24px] whitespace-pre-line"}>
                                        <div dangerouslySetInnerHTML={{__html: kHomeTexts.punchline}}/>
                                    </span>
                            </div>
                            <div className={"w-full text-center"}>
                                    <span className={"text-greyLight9 font-normal text-[18px]"}>
                                       {aboutScreenHighlightWords(kHomeTexts.subPunchline, ['Ummia te guide', 'maîtrise', 'savoir-faire', "d'apprendre en pratiquant", 'pas à pas'])}
                                    </span>
                            </div>
                        </div>
                        <div className={"flex justify-center"}>
                            <SystemPrimaryCustomButton
                                label={"Télécharger l'application"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                sizeStyle={kButtonStyles.mediumButtonStyle}
                                extraClass={"text-[16px]"}
                                onButtonClick={scrollToDownload} />
                        </div>
                    </div>
                </div>
                {/** HOME MISSION */}
                <div className={"bg-backgroundLight3 w-full flex flex-col justify-center items-center py-[32px] px-[16px]"}>
                    <div className={"w-full flex flex-col space-y-[24px]"}>
                        <div className={"flex flex-col justify-start items-start"}>
                            <div className={"flex flex-col space-y-[16px] justify-start items-start"}>
                                    <span className={"text-[26px] font-bold text-white leading-none"}>
                                        {kHomeTexts.missionTitle}
                                    </span>
                                <span className={"font-normal text-[16px] text-greyLight9"}>
                                        {aboutScreenHighlightWords(kHomeTexts.missionContent, ['réussisse scolairement', 'maitrise', 'savoir-faire', 'fondamentaux'])}
                                    </span>
                            </div>
                        </div>
                        <div className="flex aspect-video">
                            <iframe
                                className="w-full h-full rounded-[16px]"
                                src={kYoutubeVideoLink}
                                title="Projet Ummia"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen />
                        </div>
                    </div>
                </div>
                {/** HOME SECTION DIVIDER */}
                <div className={"bg-backgroundLight3 w-full flex justify-center px-[16px] py-[8px]"}>
                    <div className={"w-full h-[1px] min-h-[1px] bg-greyLight3"}>
                    </div>
                </div>
                {/** HOME DOWNLOAD MOBILE APP */}
                <div ref={downloadSectionRef}
                     className={"bg-backgroundLight3 w-full flex flex-col justify-center items-center py-[32px] px-[16px]"}>
                    <div className={"w-full flex flex-col justify-start items-start space-y-[32px]"}>
                        <div className={"w-full flex flex-col justify-start items-start space-y-[24px]"}>
                            <div className={"flex flex-col space-y-[16px] justify-start items-start"}>
                                    <span className={"text-[26px] font-bold text-white leading-none"}>
                                        {"Télécharge l'application mobile"}
                                    </span>
                                <span className={"font-normal text-[16px] text-greyLight9"}>
                                        {aboutScreenHighlightWords("Emmène Ummia partout avec toi avec les versions iOS et Android de l'application.", ['Emmène', 'partout', 'Android', 'iOS'])}
                                    </span>
                            </div>
                            <div className={"w-full flex justify-start items-center space-x-[24px]"}>
                                <HomeAppStoreButton />
                                <HomePlayStoreButton />
                            </div>
                        </div>
                        <div className={"w-full h-[320px] min-h-[320px] flex items-center justify-center"}>
                            <img className={"object-contain h-full"}
                                 src={kHomeScreenImages.foxWithPhone}
                                 alt="Mobile" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}